import React from 'react'
import { Stack, Typography, Container, Button, Chip, Grid, Box, Card, Rating, TextField } from "@mui/material";
import Navbar from '../../components/Navbar';
import ShowRouting from '../../components/ShowRouting';
import UserImage from '../../assets/Images/Person1.png'
import StarIcon from "@mui/icons-material/Star";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import CreateIcon from '@mui/icons-material/Create';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import Footer from '../../components/Footer'
import { Link } from 'react-router-dom'

const CompleteRating = () => {
    const [value, setValue] = React.useState(2);
    return (
        <>
            <Navbar />

            <Container>
                <ShowRouting route={'Home / Profile / My Bookings / Booking Details / Rate Experience'} />
                <Typography variant="h6" gutterBottom component="div">
                    Rate your experience
                </Typography>

                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card

                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Rate your experience with the expert
                            </Typography>
                            <Rating
                                name="simple-controlled"
                                value={value}
                                onChange={(event, newValue) => {
                                    setValue(newValue);
                                }}
                            />
                        </Card>
                    </Grid>

                </Grid>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card

                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Enter the details of your Experience
                            </Typography>
                            <TextField fullWidth id="outlined-basic" label="Enter the details of your Experience" variant="outlined" />
                        </Card>
                    </Grid>

                </Grid>





                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Want to add tip? (Optional)

                                <Button className='ml-16 mb-2' startIcon={<CreateIcon />}>Edit</Button>
                            </Typography>

                            <TextField fullWidth id="outlined-basic" label="Amount" variant="outlined" size="small" />

                        </Card>
                    </Grid>

                </Grid>






                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Pricing
                            </Typography>
                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 19 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Item Price


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        20$


                                    </Typography>
                                </Stack>
                            </Stack>

                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 17 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Extra Service


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        0$


                                    </Typography>
                                </Stack>
                            </Stack>
                            <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 23 }}>
                                <Stack className='ml-16'>
                                    <Typography variant="body2" gutterBottom className='ml-7'>
                                        Total


                                    </Typography>
                                </Stack>
                                <Stack >
                                    <Typography variant="body2" gutterBottom >

                                        20$


                                    </Typography>
                                </Stack>
                            </Stack>
                        </Card>
                    </Grid>

                </Grid>
                <Grid container className='mb-4'>
                    <Grid item xs={8} md={8} lg={8} className='mt-10'>
                        <Card
                            sx={{

                            }}
                        >
                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px' }}>
                                Payment Method
                            </Typography>
                            <Stack style={{ padding: '30px' }}>
                                <Box

                                    sx={{
                                        width: 300,
                                        height: 150,

                                        backgroundColor: 'primary.dark',

                                    }}
                                >
                                    <Stack>
                                        <Stack>
                                            <Typography variant="h6" gutterBottom component="div" style={{ padding: '10px', }} color='white'>
                                                Visa
                                            </Typography>
                                        </Stack>

                                        <Stack className='ml-7'>
                                            <Typography variant="body2" gutterBottom color='white'>
                                                Jhon Doe
                                            </Typography>
                                        </Stack>

                                        <Stack direction='row' spacing={{ xs: 4, sm: 4, md: 13 }} className='mt-4'>
                                            <Stack className='ml-7'>
                                                <Typography variant="body2" gutterBottom color='white'>
                                                    ••••••••••••3456
                                                </Typography>
                                            </Stack>
                                            <Stack >
                                                <Typography variant="body2" gutterBottom color='white'>
                                                    10/23
                                                </Typography>
                                            </Stack>
                                        </Stack>
                                    </Stack>
                                </Box>
                            </Stack>
                        </Card>
                    </Grid>

                </Grid>
            </Container>
            <Footer />

        </>
    )
}

export default CompleteRating